export default __webpack_public_path__ + "static/media/italic.422fc505.woff";